var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeco3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 505,
    height: 49,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1A1A1A"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(489.65 16.26)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.43 0l2.01 2.45S8.01 6.31 0 7.44C0 7.43 6.53 5.58 6.43 0zm0 16l2.01-2.45S8.01 9.69 0 8.56c0 0 6.53 1.86 6.43 7.44z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.28 8L11.9 6.38 3.87 8 11.9 9.62z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(226.71 33.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.24 13.52l-3.77-.37S7.57 9.52 13.39 1.8c.01 0-3.94 7.09.85 11.72zM.72 0l.37 3.77S4.72 6.67 12.44.85C12.44.84 5.35 4.79.72 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 14.24L4.22 12.75 9.65 4.59 1.49 10.02z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M234.69 40.8l-.71-.71c10.53-10.53 24.53-16.33 39.42-16.33h225.04v1H273.41c-14.63 0-28.38 5.69-38.72 16.04z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(.39 16.05)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.85 16l-2.01-2.45s.43-3.86 8.44-4.99c0 0-6.53 1.86-6.43 7.44zm0-16L6.84 2.45s.43 3.86 8.44 4.99c0-.01-6.53-1.87-6.43-7.44z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 8L3.38 9.61 11.42 8 3.38 6.38z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(264.37 .26)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 .72l3.77.37S6.68 4.72.85 12.44c0 0 3.95-7.09-.85-11.72zm13.52 13.52l-.37-3.77S9.52 7.57 1.8 13.39c0 0 7.09-3.95 11.72.85z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.24 0L10.02 1.49 4.59 9.64 12.75 4.22z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M231.92 24.55H6.88v-1h225.04c14.62 0 28.37-5.69 38.71-16.04l.71.71c-10.53 10.53-24.53 16.33-39.42 16.33z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeco3);
export default __webpack_public_path__ + "static/media/deco3.5ce2cb10f836087d6689bd250225c3e1.svg";
export { ForwardRef as ReactComponent };